export default "__VITE_ASSET__C3$hh3AF__"